export default __webpack_public_path__ + "static/divakar_manoj-791bd1b354c20fb65a0781fcfe8849b1.jpeg";